var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _ellipse, _path46, _ellipse2, _ellipse3, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtc05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.189453,
    y: 0.90625,
    width: 350,
    height: 233,
    fill: "#446597"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.366 187.465C216.7 191.751 225.411 192.41 230.942 192.41C235.552 192.149 237.237 189.942 237.082 188.984C236.8 187.247 237.411 186.164 235.013 183.559C232.615 180.954 218.641 172.055 211.863 169.125C205.085 166.194 197.675 164.933 194.866 167.714C192.917 169.643 193.297 172.973 194.866 175.955C196.083 178.27 201.256 183.808 208.366 187.465Z",
    fill: "#0F0D22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259.62 151.22C270.064 157.681 278.625 157.114 282.298 157.114C288.535 156.923 290.595 154.14 290.451 153.303C290.19 151.784 290.757 150.836 288.535 148.559C286.312 146.281 273.365 138.499 267.085 135.937L267.057 135.926C260.78 133.364 252.355 129.927 249.756 132.355C247.95 134.042 248.762 139.248 250.216 141.855C251.669 144.463 253.401 147.373 259.62 151.22Z",
    fill: "#0F0D22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.833 146.371C178.527 144.604 177.004 140.954 177.004 137.604C177.18 132.992 178.395 135.969 179.316 135.969C180.237 135.969 182.351 139.806 182.965 143.047C183.579 146.288 198.173 162.006 186.28 153.203C183.186 150.912 181.119 148.113 179.851 146.396L179.833 146.371Z",
    fill: "#0F0D22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 167.992L208.912 163.363L210.728 164.649C211.78 165.394 211.924 166.47 211.279 167.382C210.625 168.305 209.561 168.507 208.493 167.751L207.662 167.162L206.594 168.671L205.635 167.992ZM208.21 166.389L208.887 166.869C209.457 167.272 209.961 167.149 210.288 166.68C210.617 166.222 210.559 165.715 209.992 165.309L209.314 164.829L208.21 166.389Z",
    fill: "#AAA0E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.993 171.164C209.692 170.952 209.619 170.54 209.836 170.247C210.038 169.948 210.45 169.881 210.749 170.097C211.035 170.295 211.112 170.709 210.904 171.003C210.693 171.3 210.277 171.366 209.993 171.164Z",
    fill: "#AAA0E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.344 172.035L214.622 167.406L216.438 168.692C217.489 169.436 217.634 170.513 216.989 171.424C216.335 172.348 215.27 172.55 214.203 171.794L213.372 171.205L212.303 172.714L211.344 172.035ZM213.919 170.431L214.597 170.911C215.166 171.314 215.671 171.191 215.998 170.722C216.327 170.264 216.268 169.757 215.702 169.351L215.024 168.871L213.919 170.431Z",
    fill: "#AAA0E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.628 170.951L216.35 175.58L215.404 174.91L218.682 170.281L219.628 170.951Z",
    fill: "#AAA0E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.609 177.284C217.546 176.527 217.381 175.378 218.163 174.281C218.918 173.207 220.093 172.95 221.11 173.67C222.021 174.315 222.333 175.4 221.495 176.583L221.305 176.851L218.933 175.172C218.562 175.696 218.644 176.239 219.13 176.588C219.456 176.813 219.785 176.836 220.025 176.694L220.927 177.332C220.337 177.879 219.468 177.888 218.609 177.284ZM219.354 174.577L220.831 175.623C221.127 175.199 221.051 174.689 220.627 174.393C220.194 174.082 219.656 174.191 219.354 174.577Z",
    fill: "#AAA0E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210.612 188.075C218.658 192.051 227.067 192.662 232.407 192.662C236.857 192.42 238.484 190.372 238.334 189.484C238.062 187.873 238.652 186.868 236.337 184.452C234.021 182.036 220.531 173.781 213.988 171.063C207.444 168.345 200.29 167.175 197.578 169.754C195.696 171.544 196.064 174.632 197.578 177.398C198.753 179.546 203.747 184.683 210.612 188.075Z",
    fill: "#17161E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M263.38 148.601C274.263 155.455 283.182 154.854 287.009 154.854C293.508 154.651 295.655 151.698 295.505 150.81C295.233 149.199 295.823 148.194 293.508 145.778C291.192 143.362 277.702 135.107 271.158 132.389L271.129 132.377C264.588 129.66 255.811 126.014 253.103 128.589C251.221 130.379 252.067 135.901 253.581 138.667C255.096 141.433 256.901 144.52 263.38 148.601Z",
    fill: "#17161E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.197 143.386C176.023 141.75 174.652 138.373 174.652 135.274C174.811 131.007 175.904 133.761 176.732 133.761C177.561 133.761 179.462 137.312 180.015 140.31C180.567 143.309 193.695 157.852 182.997 149.707C180.213 147.588 178.354 144.998 177.213 143.408L177.197 143.386Z",
    fill: "#17161E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174.482 134.385C174.956 144.5 188.729 154.459 195.556 158.173L195.283 146.714C193.023 145.153 187.828 142.08 181.424 136.377C176.302 131.814 174.662 123.677 174.482 120.18V134.385Z",
    fill: "#8D3D02"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M195.576 158.192L195.293 146.994L197.432 145.441L197.549 156.359L195.576 158.192Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M195.919 156.363L195.73 148.608L197.104 147.484L197.209 155.195L195.919 156.363Z",
    fill: "#A3A3A3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.919 156.36L195.73 148.605L202.197 152.221L201.287 159.363L195.919 156.36Z",
    fill: "#B66021"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M291.207 144.809C292.034 146.071 292.197 149.073 291.205 151.388",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M292.982 145.945C293.349 146.723 293.863 148.819 292.982 150.98",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M303.473 138.844C304.655 139.052 306.826 140.205 306.055 143.155",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M305.068 140.758C305.37 141.049 305.882 142.071 305.52 143.831",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M305.914 127.8C306.407 127.558 307.524 127.106 308.054 127.227",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M306.365 126.388C306.606 126.257 307.196 125.996 307.631 125.996",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M302.244 132.403C302.84 132.199 304.184 131.913 304.797 132.403",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M302.391 131.585C302.602 131.396 303.372 131.007 304.765 130.969",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M275.412 111.705C275.421 110.839 275.25 108.843 274.488 107.781",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M275.931 111.558C276.114 110.586 276.266 108.257 275.412 106.711",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M292.221 116.006C292.388 115.261 292.995 113.653 294.089 113.18",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M292.797 116.572C293.014 115.846 293.822 114.193 295.32 113.398",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M242.497 189.39C242.21 189.595 241.342 189.816 240.162 189.062",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M243.289 188.714C243.014 188.862 242.313 189.015 241.707 188.438",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M249.307 177.191C248.895 177.295 247.67 177.439 246.074 177.191",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M249.409 176.367C248.974 176.482 247.835 176.642 246.762 176.367",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M242.387 183.484C242.645 183.932 243.426 184.874 244.483 185.056",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M242.635 182.961C242.787 183.325 243.332 184.086 244.298 184.214",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M223.012 141.337C218.231 140.831 214.271 143.657 212.889 145.133C216.779 157.67 221.974 183.773 222.537 187.654C223.24 192.505 238.153 193.529 242.441 189.592C245.938 186.749 249.21 181.255 249.726 174.027C250.148 168.125 246.633 157.577 241.009 151.25C235.385 144.922 228.987 141.969 223.012 141.337Z",
    fill: "#141414"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M214.399 144.083C212.327 144.597 212.183 145.914 211.51 146.778C218.028 161.339 230.004 190.312 232.139 190.983C234.807 191.821 240.889 188.202 242.955 181.598C244.812 176.49 243.911 169.478 242.332 165.172C239.282 156.852 233.084 149.812 226.988 146.286C220.776 142.692 215.318 143.855 214.399 144.083Z",
    fill: "#8D3D02"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M212.921 144.773L203.863 150.334C203.779 158.269 205.02 175.608 210.658 181.484C217.705 188.829 223.809 190.467 229.119 191.31C234.429 192.154 237.788 188.443 238.79 187.24L238.819 187.206C240.243 185.499 243.869 181.15 242.708 170.977C239.961 158.303 231.914 150.935 226.319 147.342C221.363 144.16 215.393 144.127 212.921 144.773Z",
    fill: "#DF8654"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M202.277 152.261L195.73 148.608L197.104 147.484L203.567 151.093L202.277 152.261Z",
    fill: "#DFCDBF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M258.237 121.78L258.234 106.974L260.089 105.074L260.092 120.03L258.237 121.78Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M194.621 118.907C185.851 123.455 181.478 131.252 182.489 135.43C179.19 132.123 177.979 130.47 177.66 128.927C176.649 125.336 174.713 119.327 179.566 114.411C185.632 108.265 192.945 104.556 203.909 101.968C213.129 99.7908 225.644 98.9611 237.532 100.574C247.197 101.885 255.813 104.876 258.234 106.658V121.635C254.817 120.526 251.516 118.878 235.552 115.447C219.588 112.015 204.978 113.535 194.621 118.907Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M208.66 148.746C199.652 149.257 199.323 159.459 199.919 164.606C200.94 170.263 203.741 174.433 206.959 178.309C217.192 190.1 226.61 188.183 228.739 187.071C230.992 185.894 236.455 180.895 234.949 172.481C233.792 166.015 228.247 159.139 225.846 156.7C223.403 154.218 217.019 148.271 208.66 148.746Z",
    fill: "#DF8654"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M208.944 153.994C199.62 154.14 199.909 162.801 201.22 167.113C204.419 176.485 212.703 182.964 215.983 184.388C219.71 186.006 227.638 185.622 229.512 180.229C231.386 174.835 229.033 169.658 228.589 168.682C228.362 168.183 220.6 153.811 208.944 153.994Z",
    fill: "#8D3D02"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M265.103 112.449L258.557 108.796L259.931 107.672L266.393 111.281L265.103 112.449Z",
    fill: "#DFCDBF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M258.746 119.156L258.557 108.797L265.024 112.413L264.113 122.16L258.746 119.156Z",
    fill: "#B66021"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M197.45 145.438L195.292 146.99C183.237 140.809 177.692 133.484 175.756 128.285C172.149 118.604 177.261 113.774 180.267 110.977C183.73 107.48 193.709 100.686 207.666 98.8754C215.039 97.9189 220.913 97.3524 229.533 97.8554C246.563 99.1274 256.988 103.189 260.079 105.073L258.211 106.988C256.232 105.857 249.083 103.528 245.608 102.743C240.46 101.674 227.67 99.7254 217.691 100.486C205.218 101.436 199.798 102.922 197.422 103.872C195.046 104.823 188.598 106.803 183.331 111.317C178.611 115.363 177.36 117.741 176.993 120.147C175.84 132.122 190.574 142.101 197.45 145.438Z",
    fill: "#DFCDC0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M252.835 130.162C252.723 128.991 253.763 125.355 254.298 123.684L255.9 126.679L263.286 138.036C268.302 141.055 278.391 147.135 278.614 147.302C278.837 147.47 291.619 146.722 297.983 146.327C300.932 144.19 306.58 140.614 305.577 143.401C304.323 146.884 299.028 155.106 283.63 154.479C268.233 153.852 259.927 145.294 256.65 140.872C253.58 136.728 252.974 131.626 252.835 130.162Z",
    fill: "#DF8654"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.315,
    cy: 128.819,
    rx: 28.8611,
    ry: 21.6256,
    transform: "rotate(22.8984 281.315 128.819)",
    fill: "#141414"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M262.881 142.332C263.001 141.54 263.471 139.771 264.392 139.023",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.858,
    cy: 125.219,
    rx: 13.5439,
    ry: 8.23092,
    transform: "rotate(22.8984 281.858 125.219)",
    fill: "#592A10"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.2,
    cy: 127.083,
    rx: 11.5765,
    ry: 7.03533,
    transform: "rotate(22.8984 283.2 127.083)",
    fill: "#141414"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.416 136.855C288.714 141.205 299.205 139.657 301.848 133.399C304.491 127.141 298.286 118.542 287.988 114.192C277.691 109.842 267.2 111.39 264.556 117.648C261.913 123.906 268.118 132.505 278.416 136.855ZM280.466 132.004C286.355 134.492 292.355 133.607 293.867 130.028C295.379 126.448 291.83 121.53 285.94 119.042C280.051 116.555 274.051 117.439 272.539 121.019C271.027 124.598 274.576 129.516 280.466 132.004Z",
    fill: "#8D3D02"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M253.652 126.499C253.956 125.318 255.029 122.752 256.888 121.934",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M254.213 129.244C254.357 128.189 254.939 125.934 256.119 125.359",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M261.982 141.616C262.234 140.321 263.263 137.336 265.363 135.754",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M261.133 140.808C261.2 139.577 261.827 136.886 263.802 135.969",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M278.392 136.914C278.413 137.755 278.238 139.725 277.369 140.876",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M279.199 137.266C279.295 137.607 279.429 138.48 279.199 139.247",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M236.054 146.773C235.692 146.824 234.913 147.088 234.689 147.734",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M235.466 146.293C234.906 146.486 233.671 147.072 233.211 147.877",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M245.652 158.785C245.226 158.916 244.129 159.324 243.146 159.914",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M246.13 159.418C245.803 159.528 245.009 159.854 244.451 160.279",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M220.257 143.763C220.212 143.344 220.359 142.392 221.303 141.941",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M220.795 143.924C220.822 143.611 221.01 142.921 221.546 142.664",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M228.865 147.326C228.99 146.951 229.396 146.173 230.018 146.066",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M237.844 156.39C238.147 155.988 238.953 155.152 239.747 155.023",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M238.057 156.714C238.343 156.428 239.033 155.824 239.504 155.695",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.049 164.986L210.996 161.34L212.366 162.823C213.202 163.728 213.097 164.719 212.342 165.422C211.584 166.117 210.585 166.135 209.744 165.224L209.039 164.461L207.703 165.695L207.049 164.986ZM209.623 163.922L210.237 164.587C210.733 165.119 211.255 165.082 211.672 164.697C212.094 164.306 212.164 163.797 211.671 163.263L211.057 162.598L209.623 163.922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.384 168.685C210.168 168.45 210.18 168.081 210.417 167.867C210.643 167.652 211.01 167.672 211.229 167.904C211.436 168.133 211.426 168.5 211.197 168.712C210.963 168.928 210.593 168.911 210.384 168.685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.465 169.768L215.413 166.121L216.783 167.604C217.619 168.509 217.514 169.501 216.758 170.203C216.001 170.898 215.002 170.916 214.161 170.006L213.456 169.243L212.12 170.476L211.465 169.768ZM214.039 168.704L214.654 169.369C215.15 169.901 215.671 169.864 216.089 169.478C216.511 169.088 216.581 168.579 216.088 168.044L215.473 167.379L214.039 168.704Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.21 170.232L215.263 173.879L214.618 173.181L218.566 169.535L219.21 170.232Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.031 175.913C216.208 175.022 216.296 173.925 217.223 173.069C218.138 172.223 219.274 172.205 220.054 173.05C220.724 173.775 220.848 174.822 219.809 175.782L219.591 175.983L217.683 173.917C217.188 174.394 217.163 174.968 217.581 175.415C217.86 175.723 218.18 175.806 218.44 175.733L219.07 176.414C218.442 176.762 217.665 176.6 217.031 175.913ZM218.159 173.481L219.451 174.88C219.852 174.504 219.895 173.96 219.525 173.559C219.139 173.142 218.558 173.158 218.159 173.481Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtc05);
export default __webpack_public_path__ + "static/media/etc_05.6cf11ac80f54ee8e51fb0a2e4bd8017f.svg";
export { ForwardRef as ReactComponent };